import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./app.developer.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * DeveloperApi class.
 */
export default class DeveloperApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.developer;
    }

    /**
     * Get developer application config
     * @returns {promise}
     */
    getListOfApps() {
        return this.$http.get(this.config.applicationList).then(responseDataExtractor);
    }

    /**
     * Create application
     * @returns {promise}
     */
    create(app) { // eslint-disable-line
        // TODO: should be refactoring with real API
        const returnedApp = {
            name: app.name,
            id: Math.floor(Math.random() * 1000000000000000000),
            description: null,
            image: null,
            secret: Math.floor(Math.random() * 1000000000000000000)
        };

        const promise = new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(returnedApp);
                reject('Error');
            }, 1000);
        });

        return promise;
    }

    /**
     * Update application
     * @returns {promise}
     */
    update(app) { // eslint-disable-line
        const promise = new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(app);
                reject('Error');
            }, 1000);
        });

        return promise;
    }

}



// WEBPACK FOOTER //
// ./app/services/api/developer/developer.service.js